module.exports = __webpack_public_path__ + "static/media/Dresser.0cf53e57.png";